export default __webpack_public_path__ + "static/media/products-list.e608dcb9.svg";